// extracted by mini-css-extract-plugin
export var editInput = "_hj-0";
export var editInputCompact = "_hj-2";
export var editInputLarge = "_hj-1";
export var editInputSmall = "_hj-3";